import { createRouter, createWebHistory, type RouteRecordRaw } from "vue-router";
import adminRoutes from "@/router/items/AdminRoutes.ts";

const routes = [...adminRoutes] as RouteRecordRaw[];
const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior() {
    return { top: 0 };
  },
});

export default router;
